import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the table view for balance history.
 * @extends JetView
 */
export default class tableJackpotInternationalReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        // Helper: normaliza nombre/label de país a código ISO-2 en minúsculas
        function toIsoCountry(input){
            var map = {
                'peru':'pe','perú':'pe','pe':'pe',
                'ecuador':'ec','ec':'ec',
                'colombia':'co','co':'co',
                'mexico':'mx','méxico':'mx','mx':'mx',
                'chile':'cl','cl':'cl',
                'argentina':'ar','ar':'ar',
                'brazil':'br','brasil':'br','br':'br',
                'uruguay':'uy','uy':'uy',
                'paraguay':'py','py':'py',
                'comoros':'km','km':'km'
            };
            var s = (input||'').toString().trim();
            if (!s) return '';
            var k = s.toLowerCase();
            // quita tildes/acentos si el navegador lo soporta
            try { k = k.normalize('NFD').replace(/[\u0300-\u036f]/g,''); } catch(e) {}
            return map[k] || (k.length === 2 ? k : '');
        }
        // Helper: map ISO code to Spanish country name
        function isoToName(iso){
            var map = {
                'pe':'Perú',
                'ec':'Ecuador',
                'co':'Colombia',
                'mx':'México',
                'cl':'Chile',
                'ar':'Argentina',
                'br':'Brasil',
                'uy':'Uruguay',
                'py':'Paraguay',
                'km':'Comoras'
            };
            return map[(iso||'').toLowerCase()] || '';
        }

        /**
         * Marks old values in the BalanceGap column based on specified conditions.
         * @param {number} value - The value to evaluate.
         * @param {Object} config - The configuration object.
         * @returns {Object} CSS styles for the cell.
         */
        function mark_old(value, config) {
            var num = webix.Number.parse(value, {
                decimalSize: 2,
                groupSize: 3,
                decimalDelimiter: '.',
                groupDelimiter: ',',
            });
            if (num > 30 && num < 99) {
                return { background: 'orange' }; // Orange background for values between 30 and 99
            }
            if (num > 100) {
                return { background: 'red' }; // Red background for values greater than 100
            }
        }

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'treetable', // Treetable view for displaying hierarchical data
                            id: 'datatable', // Unique identifier for the datatable
                            css: 'webix_header_border webix_data_border', // CSS classes for styling
                            scheme: {
                                $change: function (item) {
                                    // Change event for item updates
                                    if (item.BalanceEnd != item.BalanceEndCalc) {
                                        item.$css = { background: '#FFAAAA' }; // Highlight changed items
                                        if (item.BalanceEnd > item.BalanceEndCalc) {
                                            item.BalanceGap = item.BalanceEnd - item.BalanceEndCalc; // Calculate balance gap
                                        } else {
                                            item.BalanceGap = item.BalanceEndCalc - item.BalanceEnd; // Calculate balance gap
                                        }
                                    }
                                },
                            },
                            columns: [
                                {
                                    id: 'ParentJackpotID', // Column for ParentJackpotID
                                    header: _('ID Padre Jackpot'), // Localized header
                                    width: 250,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'JackpotID', // Column for JackpotID
                                    header: _('ID Jackpot'), // Localized header
                                    width: 250,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Name', // Column for Name
                                    header: _('Nombre'), // Localized header
                                    width: 250,
                                    sort: 'text', // Sorting type
                                },
                                {
                                    id: 'StardDate', // Column for StardDate
                                    header: _('Fecha de inicio'), // Localized header
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 250,
                                    sort: 'text', // Sorting type

                                },
                                {
                                    id: 'Partner', // Column for Partner
                                    header: _('Partner'), // Localized header
                                    width: 250,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Country',
                                    header: _('País'),
                                    hidden: !devConfig.getPermAction('sensitiveInformationCountry', 'Add'),
                                    css: 'prm-filterByCountry',
                                    width: 100,
                                    sort: 'text',
                                    template: function (obj) {
                                        // Prefer CountryName si viene del API; si no, usa Country o CountryCode
                                        var raw = obj.CountryName || obj.Country || obj.CountryCode || '';
                                        var iso = toIsoCountry(raw);

                                        // Determina el nombre a mostrar
                                        var name = '';
                                        if (obj.CountryName) {
                                            name = obj.CountryName;
                                        } else if (raw && raw.length === 2) {
                                            name = isoToName(iso) || raw;
                                        } else {
                                            name = raw;
                                        }

                                        var flagHtml = iso ? ("<i class='flags " + iso + "'></i>") : '';
                                        var nameHtml = webix.template.escape(String(name));

                                        if (!flagHtml && !nameHtml) return '';
                                        return flagHtml + (flagHtml && nameHtml ? " <span style='margin-left:6px'>" + nameHtml + "</span>" : nameHtml);
                                    }
                                },
                                {
                                    id: 'LocalJackpotValue', // Column for LocalJackpotValue
                                    header: _('Valor acumulado local'), // Localized header
                                    width: 250,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'BaseJackpotValue', // Column for BaseJackpotValue
                                    header: _('Valor acumulado base'), // Localized header
                                    width: 250,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'NumberOfParticipants', // Column for NumberOfParticipants
                                    header: _('Cantidad de participantes'), // Localized header
                                    width: 250,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'NumberOfLaps', // Column for NumberOfParticipants
                                    header: _('Cantidad de caidas'), // Localized header
                                    width: 150,
                                    sort: 'int', // Sorting type
                                    hidden: true // oculto por defecto; se mostrará sólo cuando Type === '1'
                                },
                                {
                                    id: 'DateOfWinning', // Column for DateOfWinning
                                    header: _('Fecha de caída'), // Localized header
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 250,
                                    sort: 'text', // Sorting type
                                },
                                {
                                    id: 'PlayerID', // Column for PlayerID
                                    header: _('ID Jugador (ganador)'), // Localized header
                                    width: 250,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'BetID', // Column for BetID
                                    header: _('ID Apuesta (de la apuesta ganadora)'), // Localized header
                                    width: 250,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'BaseCurrency', // Column for BaseCurrency
                                    header: _('Moneda base'), // Localized header
                                    width: 250,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Status',
                                    header: _('Estado'),
                                    width: 100,
                                    sort: 'text',
                                    template: function (obj) {
                                        var v = obj.Status != null ? String(obj.Status).toUpperCase() : (obj.State != null ? String(obj.State).toUpperCase() : '');
                                        if (v === 'G') return _('Ganado');
                                        if (v === 'A') return _('Activo');
                                        if (v === 'I') return _('Inactivo');
                                        return v; // fallback para valores inesperados
                                    }
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    // Event before loading data
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    // Overlay handling centralizado en init() → grid.attachEvent('onAfterLoad')
                                },
                            },
                            ready: function () {
                                // Event when the datatable is ready
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px; text-align:center;'>" +
                                            "No hay registro de jackpots creados en el rango de fechas consultado. Intenta aumentar el rango de fechas para buscar más información" +
                                            "</div>"
                                    );
                                }
                            },
                            footer: false, // Enable footer
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math calculations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch size
                            pager: 'jackpotPager', // Pager ID for pagination (unique for this view)
                        },
                    ],
                },
                {
                    view: 'pager',
                    id: 'jackpotPager',
                    size: devConfig.getDefaultDataFetch(),
                    group: 5,
                    template: '{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}'
                }
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        var url = devConfig.geturlApi() + 'Report/GetJackpotInternational'; // API URL for fetching balance history
        var filter = ''; // Filter string for API requests
        const _ = this.app.getService('locale')._; // Localization service

        var flag = false; // Flag for export operations
        var currentType = null; // '0' detallada (no grouping), '1' resumido (group by Partner)
        var suppressPager = false; // evita bucles al recargar/paginar

        // --- pagination helpers (server-side) ---
        var pagerCmp = null;
        webix.delay(function(){ pagerCmp = $$('jackpotPager'); });

        function pageSize(){
            return (pagerCmp && pagerCmp.config && pagerCmp.config.size) || grid.data.$pagesize || devConfig.getDefaultDataFetch();
        }

        function currentSortSuffix(){
            var st = grid.getSortState ? grid.getSortState() : null;
            if (st && st.id) return '&sort[' + st.id + ']=' + st.dir;
            return '';
        }

        function resetPager(){
            var p = $$('jackpotPager');
            if (p && typeof p.setValue === 'function') {
                if (p.blockEvent) p.blockEvent();
                p.setValue(0);
                if (p.unblockEvent) p.unblockEvent();
            }
        }

        function reloadPage(page){
            var size = pageSize();
            var start = (page||0) * size;
            var p = $$('jackpotPager');
            if (p && p.blockEvent) p.blockEvent();
            suppressPager = true;
            grid.clearAll();
            grid.load(
                url + '?start=' + start + '&count=' + size + filter + currentSortSuffix(),
                function(){
                    suppressPager = false;
                    if (p && p.unblockEvent) p.unblockEvent();
                }
            );
        }

        webix.delay(function(){
            pagerCmp = $$('jackpotPager');
            if (pagerCmp) {
                pagerCmp.attachEvent('onAfterPageChange', function(newPage){
                    if (suppressPager) return; // evita bucles cuando el pager cambia por la recarga
                    reloadPage(newPage);
                });
            }
        });
        // --- end pagination helpers ---

        // --- helpers: unique query builder (no duplicates) and date formatter ---
        function fmtDate(d) {
            var pad = function (n) { return ('00' + n).slice(-2); };
            return d.getFullYear() + ':' + pad(d.getMonth() + 1) + ':' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
        }
        function buildQuery(fd) {
            var params = {}; // unique bag
            if (!fd) return '';

            // Detecta Type (acepta fd.Type o fd.type)
            var typeVal = (fd && fd.Type != null) ? String(fd.Type) : ((fd && fd.type != null) ? String(fd.type) : undefined);
            var isSummary = (typeVal === '1');

            Object.keys(fd).forEach(function (key) {
                var value = fd[key];
                if (value === '' || value === null || value === undefined) return; // omite vacíos

                var kLower = String(key).toLowerCase();

                // Si es vista resumida: NO enviar State ni Partner en ningún caso
                if (isSummary && (kLower === 'state' || kLower === 'partner')) {
                    return; // skip
                }

                if (key === 'Datepicker') {
                    // Rango principal -> dateFrom/dateTo
                    var r1 = String(value).split(' - ');
                    if (r1[0]) params.dateFrom = r1[0].trim();
                    if (r1[1]) params.dateTo = r1[1].trim();
                    return; // no incluir Datepicker
                }
                if (key === 'Datepicker2') {
                    // Rango de caída: sólo si NO es resumido
                    // Rango de caída: sólo si NO es resumido
                    if (isSummary) return; // suprime completamente Drop*
                    var r2 = String(value).split(' - ');
                    if (r2[0]) params.DropDateFrom = r2[0].trim();
                    if (r2[1]) params.DropDateTo = r2[1].trim();
                    return; // no incluir Datepicker2
                }
                if (key === 'Date') {
                    // Fecha simple
                    var d = String(value).replace(' 00:00:00', '').trim();
                    if (d) {
                        params.dateFrom = d;
                        params.dateTo = d;
                        if (!isSummary) { params.DropDateFrom = d; params.DropDateTo = d; }
                    }
                    return; // no incluir Date
                }

                // Rango objeto {start,end} (modal custom) → solo principal
                if (typeof value === 'object' && (value.start || value.end)) {
                    if (value.start) params.dateFrom = fmtDate(new Date(value.start));
                    if (value.end)   params.dateTo   = fmtDate(new Date(value.end));
                    return;
                }

                // Default: set as is (último gana)
                params[key] = value;
            });

            // Limpieza final defensiva si es vista resumida
            if (isSummary) {
                delete params.State; delete params.state;
                delete params.Partner; delete params.partner;
                delete params.DropDateFrom; delete params.DropDateTo;
            }

            // Asegura que Type viaje si estaba presente
            if (typeVal !== undefined) params.Type = typeVal;

            var qs = '';
            Object.keys(params).forEach(function (k) {
                var v = params[k];
                qs += '&' + encodeURIComponent(k) + '=' + encodeURIComponent(v);
            });
            return qs;
        }
        // --- end helpers ---

        grid.attachEvent('onAfterLoad', function () {
            // Centraliza el manejo del overlay para ambos tipos
            if (this.count()) {
                this.hideOverlay();
            } else {
                webix.extend(this, webix.OverlayBox);
                this.showOverlay(
                    "<div class='no-data' style='margin:75px; font-size:18px; text-align:center;'>" +
                    "No hay registro de jackpots creados en el rango de fechas consultado. Intenta aumentar el rango de fechas para buscar más información" +
                    "</div>"
                );
            }

            // Reinicia agrupación antes de aplicar la del modo actual
            if (this.data.ungroup) this.data.ungroup();

            // Mostrar/ocultar la columna NumberOfLaps según el Type actual
            if (currentType === '1') {
                if (this.isColumnVisible && !this.isColumnVisible('NumberOfLaps')) this.showColumn('NumberOfLaps');
            } else {
                if (this.isColumnVisible && this.isColumnVisible('NumberOfLaps')) this.hideColumn('NumberOfLaps');
            }

            // Agrupación por Partner sólo en vista resumida
            if (currentType === '1') {
                this.data.group({ by: 'Partner', map: { Partner: ['Partner'] } });
                if (this.openAll) this.openAll();
            }
        });

        this.on(this.app, 'balanceHistory:filter', (filterData) => {
            // guarda el Type actual para decidir si se agrupa
            var typeCandidate = (filterData && filterData.Type != null)
                ? filterData.Type
                : ((filterData && filterData.type != null) ? filterData.type : null);
            currentType = (typeCandidate != null) ? String(typeCandidate) : null;

            // Aplicar inmediatamente la visibilidad de la columna antes de cargar
            if (currentType === '1') {
                if (grid.isColumnVisible && !grid.isColumnVisible('NumberOfLaps')) grid.showColumn('NumberOfLaps');
            } else {
                if (grid.isColumnVisible && grid.isColumnVisible('NumberOfLaps')) grid.hideColumn('NumberOfLaps');
            }

            var string1 = buildQuery(filterData); // clean query string (no duplicates, no Datepicker keys)
            filter = string1; // almacena filtros limpios
            resetPager();
            reloadPage(0); // recarga página 0 con start/count correctos
        });

        grid.attachEvent('onAfterSort', function (by, dir, as) {
            resetPager();
            reloadPage(0);
        });

        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event on item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        this.on(this.app, 'player:select', (Id) => {
            // Event for player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });

        this.on(this.app, "export:filter", filterData => { // Event for exporting data
            flag = true; // Set export flag
            if (flag) { // Check if export flag is set
                var size = grid.getPager().config.size; // Get pager size
                var page = grid.getPage(); // Get current page
                var first = size * page; // First item index on current page
                var last = (first + size) - 1; // Last item index on current page
                if ($$("Export").getValue() == '1') { // Check for Excel export
                    for (var j = 0; j < grid.config.columns.length; j++) {
                        if (grid.config.columns[j].exportType) {
                            delete grid.config.columns[j].format; // Remove format for export
                        }
                    }
                    this.app.callEvent('export:data', [
                        // Trigger export event
                        {
                            NameReport:
                                ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                _('Jackpot Internacional'), // Report name
                            TypeReport: 'Excel', // Report type
                        },
                    ]);
                    webix.toExcel(grid, {
                        filter: function (obj) {
                            return grid.getIndexById(obj.id) >= first && grid.getIndexById(obj.id) <= last; // Filter for current page
                        },
                        // Export to Excel
                        filename:
                            'Virtualsoft - ' +
                            new Date()
                                .toLocaleString('en-GB', {
                                    hour12: true,
                                })
                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                .replace(/[\/:]/g, '_')
                                .toUpperCase() +
                            ' - ' +
                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                            _('Jackpot Internacional'), // Filename for the export
                        ignore: { detailTittle: true }, // Ignore detail title
                        footer: false, // Do not include footer
                    });
                } else {
                    if ($$("Export").getValue() == '2') { // Check for PDF export
                        this.app.callEvent('export:data', [
                            // Trigger export event
                            {
                                NameReport:
                                    ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                    _('Jackpot Internacional'), // Report name
                                TypeReport: 'PDF', // Report type
                            },
                        ]);
                        webix.toPDF(grid, {
                            filter: function (obj) {
                                return grid.getIndexById(obj.id) >= first && grid.getIndexById(obj.id) <= last; // Filter for current page
                            },
                            // Export to PDF
                            filename:
                                'Virtualsoft - ' +
                                new Date()
                                    .toLocaleString('en-GB', {
                                        hour12: true,
                                    })
                                    .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                    .replace(/[\/:]/g, '_')
                                    .toUpperCase() +
                                ' - ' +
                                ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                _('Jackpot Internacional'), // Filename for the export
                            autowidth: true, // Auto width for PDF
                            ignore: { detailTittle: true }, // Ignore detail title
                            footer: false, // Do not include footer
                        });
                    }
                }
                flag = false; // Reset export flag
                $$("Export").setValue(""); // Reset export selection
            }
        });

    }
}

// FILE DOCUMENTED
